import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BookOpenText, BotMessageSquare, Calendar, ClipboardCheck, Code, LayoutDashboard, MessageCircle, PhoneCall, Receipt, Settings2, Speech, User, } from "lucide-react";
import { useLocation } from "react-router-dom";
import { may } from "@/abilities";
import { useAppSelector } from "@/app/hooks";
import { CustomerSwitcher } from "@/components/CustomerSwitcher";
import DemoCountdown from "@/components/DemoCountdown";
import { NavMain } from "@/components/Sidebar/nav-main";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from "@/components/ui/sidebar";
import { sessionSelector } from "@/features/sessionSlice";
import { dashboardPath, knowledgeBasePath, settingsPath, usersPath } from "@/routes";
import { accountingPath } from "@/routes/path_helpers/accounting";
import { answerReviewsPath, answerReviewSwipePath } from "@/routes/path_helpers/answerReview";
import { apiToolsPath } from "@/routes/path_helpers/apiTools";
import { callsPath } from "@/routes/path_helpers/calls";
import { chatbotsPath } from "@/routes/path_helpers/chatbots";
import { chatsPath } from "@/routes/path_helpers/chats";
import { demoBotPath } from "@/routes/path_helpers/demo";
import { followupsPath } from "@/routes/path_helpers/followups";
import { voicebotsPath } from "@/routes/path_helpers/voicebots";
import { NavFooter } from "./footer";
import UserStatusSelector from "./status-selector";
export const getNavItems = (session) => {
    const isSmall = session.customer?.attrs?.is_small_customer === true;
    return [
        {
            title: "Dashboard",
            url: dashboardPath(),
            icon: LayoutDashboard,
            may: true,
        },
        {
            title: "Chats",
            url: chatsPath(),
            icon: MessageCircle,
            may: may(session, "chats"),
        },
        {
            title: "Calls",
            url: callsPath(),
            icon: PhoneCall,
            may: may(session, "chats"),
        },
        {
            title: "Mein Bot",
            url: demoBotPath(),
            icon: BotMessageSquare,
            may: isSmall,
        },
        {
            title: "Chatbots",
            url: chatbotsPath(),
            icon: BotMessageSquare,
            may: !isSmall && may(session, "chatbots"),
        },
        {
            title: "Voicebots",
            url: voicebotsPath(),
            icon: Speech,
            may: !isSmall && may(session, "voicebots"),
        },
        {
            title: "Wissensdatenbanken",
            url: knowledgeBasePath(),
            icon: BookOpenText,
            may: !isSmall && may(session, "knowledgebase"),
        },
        {
            title: "API-Tools",
            url: apiToolsPath(),
            icon: Code,
            may: !isSmall && may(session, "api-tools"),
        },
        {
            title: "QA-Check",
            url: answerReviewsPath(),
            icon: ClipboardCheck,
            may: may(session, "answer-review"),
            items: [
                { title: "Bewertungen", url: answerReviewsPath(), may: may(session, "answer-review") },
                { title: "Antworten bewerten", url: answerReviewSwipePath(), may: may(session, "answer-review", "new") },
            ],
        },
        {
            title: "Followups",
            url: followupsPath(),
            icon: Calendar,
            may: may(session, "followups"),
        },
        {
            title: "Buchhaltung",
            url: accountingPath(),
            icon: Receipt,
            may: may(session, "accounting"),
        },
        {
            title: "Benutzer",
            url: usersPath(),
            icon: User,
            may: !isSmall && may(session, "users"),
        },
        {
            title: "Einstellungen",
            url: settingsPath(),
            icon: Settings2,
            may: may(session, "settings"),
        },
    ];
};
export function AppSidebar({ ...props }) {
    const path = useLocation().pathname;
    const session = useAppSelector(sessionSelector);
    const navItems = getNavItems(session);
    return (_jsxs(Sidebar, { variant: "floating", collapsible: "icon", ...props, children: [_jsxs(SidebarHeader, { children: [_jsx(CustomerSwitcher, {}), _jsx(UserStatusSelector, {}), _jsx(DemoCountdown, { vertical: true })] }), _jsx(SidebarContent, { children: _jsx(NavMain, { path: path, items: navItems }) }), may(session, "admin") && (_jsx(SidebarFooter, { children: _jsx(NavFooter, { path: path }) }))] }));
}
